export default {
  'goldkid-stepperAB:title': 'Балаға&nbsp;арналған&nbsp;Kaspi&nbsp;Gold картасын қалай аштырамыз?',
  'goldkid-stepperAB:step-1': 'Баланың ЖСН жазыңыз',
  'goldkid-stepperAB:step-1-noIin': 'Баланың ЖСН жоқ па?',
  'goldkid-stepperAB:step-2': 'Сіз балаңыздың телефон нөмірін SMS-код көмегімен растайсыз',
  'goldkid-stepperAB:step-2-desc': 'Балаңыздың телефон нөміріне SMS-код жолдаймыз',
  'goldkid-stepperAB:step-3': 'Бала өзіне Kaspi.kz қосымшасын орнатып алып, телефон нөмірімен тіркеледі.',
  'goldkid-stepperAB:step-4': 'Бала тіркелгенін Kaspi QR көмегімен растайсыз'
}
